import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  colorClass?: string;
}
export function Accordion({
  title,
  children,
  colorClass = 'border-brand-green'
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border-l-4 ${colorClass} bg-brand-darker/50 mb-4 overflow-hidden transition-all`} data-id="element-170">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full p-4 flex justify-between items-center text-left hover:bg-white/5" data-id="element-171">
        <span className="font-montserrat font-bold text-lg" data-id="element-172">{title}</span>
        {isOpen ? <ChevronUpIcon data-id="element-173" /> : <ChevronDownIcon data-id="element-174" />}
      </button>
      {isOpen && <div className="p-4 pt-0 text-gray-300 border-t border-white/5" data-id="element-175">
          {children}
        </div>}
    </div>;
}